/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowRuleBase {
    getFixupPrototypeFunction() { return WorkFlowRuleBase.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowRuleBase>): WorkFlowRuleBase {
        let obj = Object.assign(new WorkFlowRuleBase(), model);
        WorkFlowRuleBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowRuleBase>): WorkFlowRuleBase {
        if (!model) return null;
        return WorkFlowRuleBase.newInstance(<WorkFlowRuleBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowRuleBase) {
        if (!obj) return;

        models.WorkFlowRuleBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowRuleBase): boolean {
        Object.setPrototypeOf(obj, WorkFlowRuleBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * name of the rule which are scanned against the workflow impacted resources.
     */
    name: string;

    /**
     * description of the rule which are scanned against the workflow impacted resources.
     */
    description: string;

    /**
     * The input with which the rules are getting scanned.
     */
    inputs: Array<string>;

    /**
     * SubCategory for which the workflow which has to be generated.
     */
    rule_category: models.WorkFlowCategory;

    /**
     * reference id for the rule which will be used in engine
     */
    reference_id: string;

    /**
     * Identity of the rule which are scanned against the workflow impacted resources.
     */
    sys_id: string;

}
